var map = {
	"./Primary4.svg": "./src/assets/images/avatars/start/Primary4.svg",
	"./Secondary4.svg": "./src/assets/images/avatars/start/Secondary4.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/avatars/start sync recursive ^\\.\\/.*4\\.svg$";